import React from "react";
import { Ad } from "../news/sidebar/ads/Ad";
import { useAccessWindowSize } from "../common/layout/useAccessWindowSize";

interface SearchAdProps {
	heading?: string;
	code?: string;
}

export function SearchAd({
	code,
	heading,
}: SearchAdProps) {
	const { isMobile } = useAccessWindowSize();
	const adCode = isMobile ? `${code}_mobile` : code;

	if (!code) {
		return null;
	}

	return <Ad code={adCode} heading={heading} />;
}
